export default {
    logo: 'MFC App Logo',
    a2hs: 'How to Add MFC App to Home Screen: Tap on Share, then select Add to Home Screen, and finally select Add. ',
}
